import { LISTING_SOURCES } from '../../constants';

export const scrollToTopOfPage = () => {
    if (window) {
        window.scrollTo({
            top: 0,
            left: 0,
        });
    }
};

export const shouldShowLogoMakerSwitcher = (
    { listings = {} } = {},
    listingSource
) => {
    switch (listingSource) {
        case LISTING_SOURCES.SEARCH:
            return listings.showListingsOnSearch;
        case LISTING_SOURCES.SUBCATEGORY:
            return listings.showListingsOnSubCategory;
        default:
            return false;
    }
};
